/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_Col_AmountInputs */

const vi_receipt_col_amount = /** @type {(inputs: Receipt_Col_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thành tiền`)
};

/**

* @param {Receipt_Col_AmountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const receipt_col_amount = /** @type {((inputs?: Receipt_Col_AmountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Col_AmountInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_receipt_col_amount(inputs)
});